// @flow
import * as React from 'react';
import { sprintf } from 'sprintf-js';
import { LISTING_TYPE_HUMAN_NAME_MAP_SEARCH } from 'utils/constants';
import SearchInputsContainer from 'containers/SearchInputsContainer';
import AmpContext from 'utils/AmpContext';
import { getHomeUrl } from 'utils/searchHomePages';
import Box from 'components/Box';
import { PrimaryButton } from 'components/Button';
import Icon from 'components/Icon';
import { SearchInput as Input } from 'components/Input';
import Hide from 'components/Hide';
import Logo from 'components/Logo';
import StaffSearchInputsContainer from 'containers/StaffSearchInputsContainer';
import NoAmp from 'containers/NoAmp';
import { gutterWidth, colors } from '../theme';

const SearchMenu = ({
  onSearch,
  defaultSearchType,
  navSection,
  qaId = 'search-menu',
  inPageHeader,
  searchFrom,
  searchMode,
  pageUrl
}: {|
  onSearch: ({ query?: string, type?: string, searchType?: string }) => void,
  defaultSearchType?: ListingType,
  navSection: 'MAIN' | 'STAFF',
  qaId?: string,
  inPageHeader?: boolean,
  searchFrom?: string,
  searchMode?: boolean,
  pageUrl?: string
|}) => {
  const isStaff = navSection === 'STAFF';
  const SearchInputsContainerComponent = isStaff
    ? StaffSearchInputsContainer
    : SearchInputsContainer;

  return (
    <>
      <NoAmp>
        <Box
          data-qa-id={qaId}
          classes={['flex', 'align-center']}
          position="relative"
          width="100%"
          bg={inPageHeader && 'white'}
          pb={inPageHeader && [gutterWidth / 2, null, null, 16]}
          pt={inPageHeader && [gutterWidth / 2 + 60, null, null, 16]}
          px={inPageHeader && gutterWidth / 2}
          height={inPageHeader && '100%'}
          borderTop={inPageHeader && `1px solid ${colors.platinum}`}
        >
          {inPageHeader && (
            <Hide xs sm md flex="0 0 auto">
              <Box height="100%" mr={[24, null, null, null, 40]}>
                <Box
                  component="a"
                  href={isStaff ? '/staff' : '/'}
                  title={`Idealist${isStaff ? ' Staff' : ''}`}
                  data-qa-id="header-logo-link"
                  display="block"
                  height="100%"
                >
                  <Logo
                    height={[36, null, null, null, 48]}
                    type={isStaff ? 'STAFF' : 'MAIN'}
                  />
                </Box>
              </Box>
            </Hide>
          )}
          <Box flex="1 1 auto" width="100%" height={inPageHeader && '100%'}>
            <SearchInputsContainerComponent
              searchMode={searchMode}
              onSearch={onSearch}
              searchSection={isStaff ? 'STAFF' : 'MAIN'}
              inPageHeader={inPageHeader}
              isStaff={isStaff}
              searchFrom={searchFrom}
              defaultSearchType={defaultSearchType}
            />
          </Box>
        </Box>
      </NoAmp>
      <AmpContext.Consumer>
        {requestIsAmp =>
          requestIsAmp &&
          pageUrl && (
            <form action={getHomeUrl(defaultSearchType || 'JOB')} target="_top">
              <input name="searchMode" value="true" hidden />
              <Input
                name="q"
                placeholder={getText('Keyword, skill, or interest')}
              />
              <Box
                component={PrimaryButton}
                size="large"
                square
                width="100%"
                py={0}
                mt="10px"
                type="submit"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height={34}
                >
                  <Icon name="search" width={16} height={16} fill="white" />
                  <Box ml={16}>
                    {sprintf(getText('Search %(type)s'), {
                      type:
                        LISTING_TYPE_HUMAN_NAME_MAP_SEARCH[
                          defaultSearchType || 'JOB'
                        ]
                    })}
                  </Box>
                </Box>
              </Box>
            </form>
          )
        }
      </AmpContext.Consumer>
    </>
  );
};

export default SearchMenu;
